export default "__VITE_ASSET__C_wx5s$b__"